import logo from "./logo.svg";
import "./App.css";
import { Route, Routes, BrowserRouter, HashRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Homepage from "./components/home.component";
import Calculator from "./components/calculator.component";
import Listing from "./components/listing.component";
import Header from "./components/header.component";
import ListingsPage from "./components/listingsPage.component";
import AboutPage from "./components/aboutPage.component";
import Footer from "./components/footer.component";
import Evaluation from "./components/evaluation.component";
import Reports from "./components/reports.component";
import Contact from "./components/contact.component";
import CommercialListings from "./components/commercial.component";
import BuyerGuide from "./components/buyerGuide.component";
import SellerGuide from "./components/sellerGuide.component";
import Location from "./components/location.component";
import { DefaultSEO } from "./components/seo.component";
import ScrollToTop from "./components/ScrollToTop.component";
import MainWrapper from "./components/mainWrapper.component";
import bgVideo from "./assets/videos/bg-video.mp4";

function App() {
  return (
    <HelmetProvider>
      <div>
        <DefaultSEO />
        <BrowserRouter>
          <ScrollToTop />
          {/* <div className="fixed inset-0 z-[-2] w-full h-full overflow-hidden pointer-events-none">
            <video
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-full object-cover min-h-screen min-w-full"
              src={bgVideo}
            />
            <div className="absolute inset-0 bg-white/70 z-10" />
          </div> */}
          <Header />
            <Routes>
              {/* <Route path="*" element={<Error />} /> */}
              <Route path="/" element={<Homepage />} />
              <Route path="/calculator" element={<Calculator />} />
              <Route path="/listing/:id" element={<Listing />} />
              <Route path="/listings" element={<ListingsPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/evaluation" element={<Evaluation />} />
              <Route path="/real-estate-reports" element={<Reports />} />
              <Route path="/contact" element={<Contact />} />
              {/* <Route path="/agents" element={<Agents />}/> */}
              <Route path="/commercial" element={<CommercialListings />} />
              <Route path="/selling-guide" element={<SellerGuide />} />
              <Route path="/buying-guide" element={<BuyerGuide />} />
              <Route path="/location/:id" element={<Location />} />
            </Routes>
          <Footer />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
